module.exports = __webpack_public_path__ + "static/madeleine-is-sleeping-e0deb44ba1b16cfba7e171521b34dc2f.jpg";